import styled, {css} from "styled-components";
import {Section} from "@acc-monorepo/gatsby-stories-acc/national/style/national";

export const journalPageStyles = css`
  --content-width-max: 1200px;
  
  li {
    margin-bottom: 0.33em;
    line-height: 1.45;
  }
`

export const StyledSection = styled(Section)`
  padding: 3rem 0;
`

